<script>
import constants from '@/constants';

export default {
    data() {
        return {
            selectedStartDate: '',
            selectedEndDate: '',
            maxDaysRange: 31, // 1 month
        };
    },
    computed: {
        dateRange() {
            return this.$store.getters.SYSTEM_ANALYTICS_DATE_RANGE;
        },
    },
    watch: {
        dateRange(newRange) {
            if (newRange && newRange.startDate && newRange.endDate) {
                this.selectedStartDate = newRange.startDate;
                this.selectedEndDate = newRange.endDate;
            }
        },
    },
    mounted() {
        if (this.dateRange && this.dateRange.startDate) {
            this.selectedStartDate = this.dateRange.startDate;
            this.selectedEndDate = this.dateRange.endDate;
        }
    },
    methods: {
        async applyDateRange() {
            if (!this.selectedStartDate || !this.selectedEndDate) {
                this.$store.commit('POPUP_ADD', {
                    title: 'VALIDATION ERROR',
                    description: ['Please select both start and end dates'],
                    color: '#FF0000',
                });
                return;
            }

            const startDate = new Date(this.selectedStartDate);
            const endDate = new Date(this.selectedEndDate);

            // Validate date range
            if (startDate > endDate) {
                this.$store.commit('POPUP_ADD', {
                    title: 'VALIDATION ERROR',
                    description: ['Start date cannot be after end date'],
                    color: '#FF0000',
                });
                return;
            }

            // Check max range (1 month)
            const daysDiff = Math.ceil(
                (endDate - startDate) / (1000 * 60 * 60 * 24)
            );
            if (daysDiff > this.maxDaysRange) {
                this.$store.commit('POPUP_ADD', {
                    title: 'VALIDATION ERROR',
                    description: [`Date range cannot exceed ${this.maxDaysRange} days`],
                    color: '#FF0000',
                });
                return;
            }

            await this.$store.dispatch('setSystemAnalyticsDateRange', {
                startDate: this.selectedStartDate,
                endDate: this.selectedEndDate,
            });

            this.$store.commit('POPUP_ADD', {
                title: 'SUCCESS',
                description: ['Date range updated'],
                color: '#00AA00',
            });
        },

        setLastWeek() {
            const endDate = new Date();
            const startDate = new Date();
            startDate.setDate(endDate.getDate() - 7);

            this.selectedStartDate = this.formatDate(startDate);
            this.selectedEndDate = this.formatDate(endDate);
            this.applyDateRange();
        },

        setLastMonth() {
            const endDate = new Date();
            const startDate = new Date();
            startDate.setDate(endDate.getDate() - 30);

            this.selectedStartDate = this.formatDate(startDate);
            this.selectedEndDate = this.formatDate(endDate);
            this.applyDateRange();
        },

        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
    },
};
</script>

<template>
    <div class="date_range_container">
        <div class="date_range_header">
            <label class="label_text">Date Range (Max 1 Month):</label>
        </div>

        <div class="date_range_inputs">
            <div class="date_input_group">
                <label class="input_label">Start Date:</label>
                <input
                    v-model="selectedStartDate"
                    type="date"
                    class="date_input"
                />
            </div>

            <div class="date_input_group">
                <label class="input_label">End Date:</label>
                <input v-model="selectedEndDate" type="date" class="date_input" />
            </div>

            <button class="button_apply" @click="applyDateRange">
                Apply
            </button>
        </div>

        <div class="quick_filters">
            <button class="quick_filter_btn" @click="setLastWeek">
                Last Week
            </button>
            <button class="quick_filter_btn" @click="setLastMonth">
                Last Month
            </button>
        </div>
    </div>
</template>

<style scoped>
.date_range_container {
    background: var(--background);
    border-radius: 4px;
    padding: 16px;
    margin-bottom: 16px;
}

.date_range_header {
    margin-bottom: 12px;
}

.label_text {
    color: var(--background-text);
    font-weight: 600;
    font-size: 14px;
}

.date_range_inputs {
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
    flex-wrap: wrap;
    align-items: flex-end;
}

.date_input_group {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.input_label {
    color: var(--background-text);
    font-size: 12px;
    font-weight: 500;
}

.date_input {
    padding: 8px 12px;
    border: 1px solid var(--border-color, #ccc);
    border-radius: 4px;
    background: var(--input-background, #fff);
    color: var(--text-color, #000);
    font-size: 14px;
    min-width: 140px;
}

.date_input:focus {
    outline: none;
    border-color: var(--main-color, #0066cc);
    box-shadow: 0 0 0 2px var(--main-color-alpha, rgba(0, 102, 204, 0.1));
}

.button_apply {
    padding: 8px 20px;
    background: var(--main-color, #0066cc);
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    transition: background 0.2s;
}

.button_apply:hover {
    background: var(--main-color-hover, #0052a3);
}

.button_apply:active {
    background: var(--main-color-active, #003d7a);
}

.quick_filters {
    display: flex;
    gap: 8px;
}

.quick_filter_btn {
    padding: 6px 12px;
    background: var(--background-secondary, #f5f5f5);
    color: var(--background-text);
    border: 1px solid var(--border-color, #ddd);
    border-radius: 4px;
    cursor: pointer;
    font-size: 13px;
    transition: background 0.2s;
}

.quick_filter_btn:hover {
    background: var(--background-hover, #ebebeb);
}

.quick_filter_btn:active {
    background: var(--background-active, #ddd);
}
</style>
